import React from "react";
import styles from "./MatchingButton.module.scss";

import chevronRight from "../../assets/images/chevron-right.svg";

// samples
import avatarSample from "../../assets/images/samples/avatar-sample.png";
import avatarSample1 from "../../assets/images/samples/avatar-sample-1.png";
import avatarSample2 from "../../assets/images/samples/avatar-sample-2.png";
import avatarSample3 from "../../assets/images/samples/avatar-sample-3.png";

const MatchingButton = ({ type = "regular" }) => (
  <div className={styles.MatchingButton} data-testid="MatchingButton">
    <div className="add-assistants">
      <a
        className={`d-inline-block btn ${type === "dark" ? "btn-lilac" : "btn-white"}`}
        href="mailto:client@getmagicnow.com"
        rel="noreferrer"
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="d-flex flex-row-reverse mr-3">
            <img src={avatarSample3} className="avatar-sample" alt="a1" />
            <img src={avatarSample2} className="avatar-sample" alt="a2" />
            <img src={avatarSample1} className="avatar-sample" alt="a3" />
            <img src={avatarSample} className="avatar-sample" alt="a4" />
          </div>
          <span>Add Assistants</span>
          <img src={chevronRight} className="ml-2" alt="" />
        </div>
      </a>
    </div>
  </div>
);

MatchingButton.propTypes = {};

MatchingButton.defaultProps = {};

export default MatchingButton;
